const locale = {
	DETAILS_PHONES_FIELD_TITLE: 'Phone number',
	DETAILS_PHONES_FIELD_DESCRIPTION: 'Description',
	DETAILS_PHONES_FIELD_TITLE_INDEX: 'Phone number {index}',
	DETAILS_PHONES_FIELD_DESCRIPTION_INDEX: 'Description {index}',
	DETAILS_PHONES_FIELD_DEFAULT: 'Default',

	DIALOG_PHONES_ADD: 'Add Phone Number',

	PHONES_ERRORS_COLUMN_COMPANY: 'Company',
	PHONES_ERRORS_COLUMN_USER: 'User',
	PHONES_ERRORS_COLUMN_COUNTRY: 'Country',
	PHONES_ERRORS_COLUMN_ERROR: 'Error',

	PHONES_ERRORS_UNEXPECTED_CHARACTER: 'Unexpected character',
	PHONES_ERRORS_INCORRECT_INTERNATIONAL_PREFIX: 'Incorrect international prefix ({country})',
	PHONES_ERRORS_MISSING_INTERNATIONAL_PREFIX: 'Missing international prefix ({country})',

	// #region Tabs
	TAB_LIST: 'List',
	TAB_ERRORS: 'Errors check'
	// #endregion
};

export default locale;
